module.exports = __webpack_public_path__ + "img/group-discussion-meeting.51929fdf.svg";